import {
  buttonsShowAll,
  cheapters,
  isUserLoggedIn,
  hasAllChaptersVisibleForLoggedIn,
} from './articleListedElements';
import { articleListedHideButtons } from './articleListedHideButtons';

export const articleListedShowAll = (): void => {
  buttonsShowAll.forEach((button) => {
    button.addEventListener('click', () => {
      showAllChaptersAndHideButtons();
    });
  });

  // hasSelectElementPagination má jen auto.cz kde má listovacka jinou logiku, pro tento web je tato funkcionalita zobrazeni celé listovacky pro přihlášené vypnuta
  if (isUserLoggedIn !== null && hasAllChaptersVisibleForLoggedIn !== null) {
    showAllChaptersAndHideButtons();
  }
};

const showAllChaptersAndHideButtons = () => {
  cheapters.forEach((div) => {
    (div as HTMLElement).style.display = 'block';
  });
  // skrytí všech tlačítek po odkrytí všech kapitol článku
  articleListedHideButtons();
};
